import { useMemo } from 'react';
import { currentUser } from 'js/utils/user';

import { User as Author } from 'js/social/UserCard';

const useCurrentUserAsAuthor = (): Author =>
  useMemo(
    () => ({
      affiliation: currentUser?.department?.university?.name,
      displayName: currentUser?.display_name || '',
      photo: currentUser?.photo,
      profileUrl: currentUser?.url,
    }),
    [],
  );

export default useCurrentUserAsAuthor;
